'use client'
import SubnavDefaultSection from './SubnavDefaultSection'
import SubnavPanelSection from './SubnavPanelSection'

export const Subnav = ({ setHoverSubnav, setHoverNavigation, data }) => {
  const Component =
    data.variant === 'list' ? SubnavDefaultSection : SubnavPanelSection

  return (
    <div
      data-testid="mega-menu-subnav-section"
      className="z-9999 absolute flex w-screen flex-row items-center justify-center"
    >
      <div
        className="min-w-100 rounded-md bg-white shadow-[0px_27px_74px_0px_rgba(29,37,47,0.11)]"
        onMouseEnter={() => setHoverSubnav(true)}
        onMouseLeave={() => {
          setHoverSubnav(false)
          setHoverNavigation(false)
        }}
      >
        <Component
          data={data}
          isMobile={false}
          setHoverSubnav={setHoverSubnav}
        />
      </div>
    </div>
  )
}

export default Subnav
